export class Action {
  constructor(
    public readonly id: number,
    public readonly parameter: unknown,
  ) {}

  getId(): number {
    return this.id;
  }

  getParam(): unknown {
    return this.parameter;
  }
}
